export const createUserAccountFormStyle = {
	wrapper: {
		maxWidth: '372px',
		width: '100%',
	},

	title: {
		textTransform: 'capitalize',
		color: 'var(--primary-700)',
		fontSize: '34px',
		fontWeight: 700,
		textAlign: 'center',
		marginBottom: '40px',
	},

	logIn: {
		display: 'flex',
		justifyContent: 'center',
		color: 'var(--neutral-500)',
	},

	button: {
		fontWeight: 400,
		height: '24px',
	},
};
